import React, { useState } from "react";
import { Clock } from "lucide-react";
import "./LocationTimeline.css";

const LocationTimeline = ({ title, subtitle, item, end }) => {
    const [hoveredCard, setHoveredCard] = useState(null);

    return (
        <div className="location-timeline-section">
            <h2 className="location-timeline-title">{title}</h2>
            <p className="location-timeline-subtitle">{subtitle}</p>

            <div className="location-timeline-grid">
                {Array.isArray(item) && item.map((loc, i) => (
                    <div
                        key={i}
                        className="location-timeline-card"
                        onMouseEnter={() => setHoveredCard(`location-${i}`)}
                        onMouseLeave={() => setHoveredCard(null)}
                        style={
                            hoveredCard === `location-${i}`
                                ? { transform: "translateY(-8px)", boxShadow: "0 12px 28px rgba(0,0,0,0.12)", borderColor: "#4F46E5" }
                                : {}
                        }
                    >
                        {loc?.title && (
                            <h3 className="location-timeline-card-title">{loc.title}</h3>
                        )}
                        {loc?.text && (
                            <p className="location-timeline-card-desc">{loc.text}</p>
                        )}

                        {loc?.time &&
                            <div className="location-timeline-duration">
                                <Clock size={18} />
                                {loc.time}
                            </div>
                        }
                        {
                            loc?.price && (
                                <div className="location-timeline-price">{loc.price}</div>
                            )
                        }
                    </div>
                ))}
            </div>

            {end &&
                <p className='location-timeline-end'>
                    {end}
                </p>
            }
        </div>
    );
};

export default LocationTimeline;
